<template>
    <div class="my-10">
        <div class="bg-white flex md:flex-row p-3 mb-5 rounded gap-3 md:gap-5">
            <router-link :to="{ name: 'mallOrders' }" class="text-base font-medium cursor-pointer text-[#828282]">
                {{ $t('nav.mallOrders') }}
            </router-link>

            <router-link :to="{ name: 'foodOrders' }" class="text-base font-medium cursor-pointer text-[#828282]">
                {{ $t('nav.foodOrders') }}</router-link>

        </div>
        <div class="flex flex-col gap-5">
            <OrderCard v-for="ord in orders" :key="ord.id" :detail="ord"></OrderCard>
        </div>
        <div v-show="orders.length === 0 && loading === false">
            <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_orders') }}</p>
        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
            <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
            </IconSpinner>

            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import OrderCard from '@cmp/OrderCard.vue'
export default {
    name: 'foodOrders',
    components: {
        OrderCard
    },
    data() {
        return {
            loading: false,
            orders: []
        }
    },
    methods: {
        async getExhibitionOrders() {
            this.loading = true
            try {
                const response = await api.get('exhibition/orders/')
                this.orders = response.data.results
            } catch {
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    created() {
        this.getExhibitionOrders()
    }
}

</script>

<style scoped>
.router-link-exact-active {
    border-bottom: 1px solid #409DBA;
    color: #000000;
}
</style>